import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';


@Injectable()
export class QuickstartStateService {
    public overrideRefund: boolean = false;


    constructor(private http: HttpClient) {
        
    }

}